import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { SupportedLanguage } from '../../../product.datamodel';
import { LegalNoticesComponent } from '../../../../legalNotices/legalNotices.component';
import { BuildInfo } from '../../../../../environments/build-info';

/*
 * Component representing the copyright section of App Store footer.
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "ama-ng-copyright-footer",
  standalone: true,
  template: `
      <div class="footer-wrap">
          <div class="container">
              <span>&copy; copyright </span>
              <a href="http://www.amadeus.com/" class="mx-2">
                  Amadeus
              </a>
              <span> {{ YEAR }}</span>
              <div class="right">
                  <a
                          href="javascript:void(0);"
                          (click)="showLegalNoticesModal()"
                          tabindex="0"
                          (keyup)="keyUpTriggered($event)"
                  >Legal notices</a
                  >
              </div>
          </div>
      </div>
  `
})
export class CopyrightFooterComponent {

  YEAR = BuildInfo.timestamp.getUTCFullYear();

  constructor(private readonly modalService: NgbModal) {}

  /**
   * Shows the legal notices on navigation and on key press enter
   * @param $event
   */
  keyUpTriggered($event: any) {
    if ($event.key === "Enter") {
      this.showLegalNoticesModal();
    }
  }

  /**
   * Shows the legal notices modal
   */
  showLegalNoticesModal() {
    const modalRef = this.modalService.open(LegalNoticesComponent, { size: 'xl' });
    modalRef.componentInstance.showNotices(SupportedLanguage.US);
  }
}
